'use client'

import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

import { Button } from '@/components/button/button'
import oopsTextImage from '@/public/images/pngs/oops-text-image.png'
import { cn } from '@/utils/cn'

import '@/styles/globals.css'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  const handleGoHome = () => {
    window.location.href = '/'
  }

  return (
    <html lang="ko">
      <body
        className={cn(
          'h-exclusionHeaderDvh gap-40pxr px-20pxr flex w-full flex-col items-center justify-center',
          'mb:h-exclusionHeaderDvh2',
        )}
      >
        <h1
          style={{ backgroundImage: `url(${oopsTextImage.src})` }}
          className={cn(
            'text-200pxr bg-clip-text bg-center font-bold text-transparent drop-shadow-xl',
            'max700:text-120pxr',
            'mb:text-82pxr',
          )}
        >
          Oops!
        </h1>
        <p
          className={cn(
            'text-20pxr text-blueDark text-center font-normal',
            'max700:text-18pxr',
            'mb:text-16pxr',
          )}
        >
          500 Internal Server Error
          <br />
          <span className={cn('text-16pxr text-gray-500')}>
            일시적인 오류가 발생했습니다.
            <br />
            잠시 후 다시 시도해 주세요.
          </span>
        </p>

        <div className={cn('gap-16pxr flex flex-col', 'mb:w-full')}>
          <Button
            className={cn('px-40pxr w-full rounded-full')}
            variant="primary"
            size="large"
            onClick={reset}
            isError
          >
            다시 시도하기
          </Button>

          <Button
            className={cn('px-40pxr w-full rounded-full')}
            variant="primary"
            size="large"
            onClick={handleGoHome}
          >
            홈페이지로 돌아가기
          </Button>
        </div>
      </body>
    </html>
  )
}
